import {
  selectActiveServiceId,
  selectIsPromotionPackageSelected,
  selectIsWithoutTopAndPremium,
  selectPublishTerms,
} from '../../../selectors/publishTerms';
import { IAppState } from '../../../../AppModulesWrapper';
import { TThunkAction } from '../../../../common/types/thunk';
import { changeActiveServiceId, setIsServicesEnabled } from '../../../actions/publishTerms';

export function enablePromotion(): TThunkAction<Promise<void>> {
  return async function (dispatch, getState) {
    const state: IAppState = getState();

    const isWithoutTopAndPremium = selectIsWithoutTopAndPremium(state);
    const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);
    const activeServiceId = selectActiveServiceId(state);
    const publishTerms = selectPublishTerms(state);

    if (isWithoutTopAndPremium || isPromotionPackageSelected) {
      return;
    }

    if (activeServiceId) {
      dispatch(setIsServicesEnabled(true));

      return;
    }

    for (const serviceId of publishTerms.serviceIds) {
      if (publishTerms.services[serviceId]?.isAvailable && !publishTerms.services[serviceId]?.unavailableReasonType) {
        dispatch(changeActiveServiceId(serviceId));
        dispatch(setIsServicesEnabled(true));
        break;
      }
    }
  };
}
